// ... imports
import { useState } from 'react';
import { Alert, Drawer } from 'antd'; // Import Drawer
import IndustryChainMap from '../components/IndustryChainMap';
import ChainNodeDetails from '../components/ChainNodeDetails';
import { LoadingIndicator, ErrorAlert } from '../components';
import { useIndustryChain } from '../hooks/useIndustryData';
import type { IndustryNode } from '../types';
import './IndustryChain.scss';

export default function IndustryChain() {
  const { data, isLoading, error, refetch } = useIndustryChain();
  const [selectedNode, setSelectedNode] = useState<IndustryNode | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleNodeClick = (node: IndustryNode) => {
    setSelectedNode(node);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorAlert error={error} onRetry={refetch} />;
  }

  return (
    <div className="industry-chain-page" style={{ position: 'relative', height: 'calc(100vh - 100px)' }}> {/* Ensure container has height */}
      <div style={{ marginBottom: '16px' }}>
        <h1>钒产业链全景图</h1>
        <p style={{ marginTop: '8px', color: 'rgba(255,255,255,0.6)' }}>
          从矿产资源到终端应用的全生命周期可视化。点击节点查看详细数据。 (数据来源: USGS, Annual Reports)
        </p>
      </div>

      {/* 产业链地图 */}
      {data && data.nodes && data.nodes.length > 0 ? (
        <div className="glass-card" style={{ height: 'calc(100% - 100px)', padding: 0, overflow: 'hidden', background: 'transparent', boxShadow: 'none', border: 'none' }}>
          <IndustryChainMap
            data={data}
            width={1400} // Wider canvas
            height={800}
            onNodeClick={handleNodeClick}
          />
        </div>
      ) : (
        <Alert
          message="暂无数据"
          description="产业链数据暂未配置,请联系管理员添加数据。"
          type="info"
          showIcon
        />
      )}

      {/* 侧边详情面板 */}
      <Drawer
        title={null}
        placement="right"
        onClose={handleCloseDrawer}
        open={isDrawerOpen}
        width={400}
        mask={false} // Non-modal
        style={{ background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(10px)', borderLeft: '1px solid rgba(0,0,0,0.05)', boxShadow: '-4px 0 16px rgba(0,0,0,0.05)' }}
        bodyStyle={{ padding: 0 }}
        headerStyle={{ display: 'none' }} // Custom header in component
      >
        {selectedNode && (
          <ChainNodeDetails node={selectedNode} onClose={handleCloseDrawer} />
        )}
      </Drawer>
    </div>
  );
}
